import * as THREE from 'three';
import { PostProcess } from '../rendering/PostProcessing';
import { GridData } from '@data/GridData';
// import modes from '../ImGUI/GuiPanels/PanelManager/modeConfig';
import { worldStatusClass } from '../Simulations/status';

/**
 * @deprecated
 */
export const globalState: {
    renderer: THREE.WebGLRenderer | null;
    scene: THREE.Scene | null;
} = {
    renderer: null,
    scene: null,
};

/**
 *  main scene of the renderer
 * @deprecated
 */
export const setScene = (sceneInput: THREE.Scene) => {
    globalState.scene = sceneInput;
};

/**
 * Gui world status
 * @deprecated
 */
export let worldStatus = new worldStatusClass();

/**
 * @deprecated
 */
export let renderer = () => globalState.renderer;

/**
 * @deprecated
 */
export const setRenderer = (rendererInput: THREE.WebGLRenderer) => {
    globalState.renderer = rendererInput;
};

/**
 * @deprecated
 */
export let postProcess: PostProcess;

/**
 * @deprecated
 */
export const setPostProcess = (postProcessInput: PostProcess) => {
    postProcess = postProcessInput;
}; //////////////////////
// Global Variables //
//////////////////////

/**
 * @deprecated
 */
export let camera: any;
/**
 * @deprecated
 */
export const setCamera = (cameraInput: any) => {
    camera = cameraInput;
};

// grid.ts (still inside your global_variables.ts)
/**
 * @deprecated
 */
export let grid: GridData;

/**
 * @deprecated
 */
export function setGrid(gridInput: GridData) {
    grid = gridInput;
}
